import { css, StyleSheet } from 'aphrodite';
import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { isServer } from '../../../store';
import newtheme from '../../newtheme';
import IconNewNoaLogoWhiteText from '../../assets/icons/IconNewNoaLogoWhiteText';
import IUser from '../../types/models/IUser';
import { MpTrackingButtons } from '../../config/buttons';
import { openModal } from '../../actions/modal';
import { IState } from '../../reducers';
import { mpTrackButtonClick } from '../../tracking/mixpanel';
import config from '../../config';
import ModalTypes from '../../types/ModalTypes';
import ISubscriptionProduct from '../../domaindriven/subscribe/types/ISubscriptionProduct';
import { getSelectedSubscriptionProduct } from '../../domaindriven/subscribe/state/selectors';
import HamburgerIcon from '../../assets/icons/Hamburger';
import CloseIcon from '../../assets/icons/CloseIcon';
import { ILandingPageHero } from '../../domaindriven/landing/types/ILandingPageHero';

interface ILocalState {
    transparentMode: boolean;
    isMenuOpen: boolean;
}

interface IProps {
    enableTransparentMode?: boolean;
}

interface IPropsFromState {
    user?: IUser;
    subscriptionProduct?: ISubscriptionProduct;
}

interface IPropsFromDispatch {
    openModal: typeof openModal;
}

class LandingPageNewNavbar extends React.Component<
    IProps & IPropsFromState & IPropsFromDispatch & RouteComponentProps,
    ILocalState
> {
    constructor(props) {
        super(props);

        this.state = { transparentMode: true, isMenuOpen: false };
    }

    public componentDidMount() {
        if (this.props.enableTransparentMode) {
            window.addEventListener('scroll', this.handleScroll);
        }
    }

    public componentWillUnmount() {
        if (this.props.enableTransparentMode) {
            window.removeEventListener('scroll', this.handleScroll);
        }
    }

    public handleScroll = () => {
        if (isServer) {
            return;
        }

        const currentScrollDistanceFromTop = window.pageYOffset;
        const heightOfWindow = window.innerHeight;

        if (currentScrollDistanceFromTop > heightOfWindow) {
            if (this.state.transparentMode) {
                this.setState({ transparentMode: false });
            }
        } else if (!this.state.transparentMode) {
            this.setState({ transparentMode: true });
        }
    };

    public showLogin = () => {
        const { subscriptionProduct } = this.props;

        mpTrackButtonClick(MpTrackingButtons.SHOW_LOGIN_NAVBAR);

        if (this.props.user) {
            if (
                subscriptionProduct &&
                subscriptionProduct.metadata.homePage &&
                subscriptionProduct.metadata.homePage.redirectToPage
            ) {
                this.props.history.push(subscriptionProduct.metadata.homePage.redirectToPage);
                return;
            }

            this.props.history.push(config.routes.homeWebPlayer);
            return;
        }

        this.props.openModal(ModalTypes.LogInNew);
    };

    public onSignUpButtonClicked = () => {
        const { subscriptionProduct } = this.props;

        if (
            subscriptionProduct &&
            subscriptionProduct.metadata.homePage &&
            subscriptionProduct.metadata.homePage.redirectToPage
        ) {
            if (this.props.user || !subscriptionProduct.metadata.homePage.showSignup) {
                this.props.history.push(subscriptionProduct.metadata.homePage.redirectToPage);
                return;
            }

            this.showSignup();
            return;
        }

        if (this.props.user) {
            this.props.history.push(config.routes.homeWebPlayer);
            return;
        }

        this.showSignup();
    };

    public showSignup = () => {
        mpTrackButtonClick(MpTrackingButtons.SHOW_SIGNUP_HERO);

        this.props.openModal(ModalTypes.SignUpNew);
    };

    public doShowClaimOffer = (subscriptionProduct?: ISubscriptionProduct) =>
        subscriptionProduct != null &&
        subscriptionProduct.metadata.homePage.redirectToPage &&
        !subscriptionProduct.metadata.homePage.showSignup;

    public claimOffer = () => {
        const { subscriptionProduct } = this.props;

        this.props.history.push(
            subscriptionProduct && subscriptionProduct.metadata.homePage.redirectToPage
                ? subscriptionProduct.metadata.homePage.redirectToPage
                : config.routes.subscribe,
        );
    };

    public chatToTeam = () => {
        this.setState((prev) => ({ ...prev, isMenuOpen: false }));
        // @ts-ignore
        if (window != null && window.Intercom != null) {
            // @ts-ignore
            window.Intercom('showNewMessage');
        }
    };

    public render() {
        const { subscriptionProduct } = this.props;
        const buttonText = (
            subscriptionProduct?.metadata.homePage.components.find(
                (section) => section.type === 'HERO',
            ) as ILandingPageHero
        )?.buttonText;

        const showSolidNavbar = !this.props.enableTransparentMode || !this.state.transparentMode;
        return (
            <div>
                <div className={css(styles.main, showSolidNavbar && styles.solidNavbar)}>
                    <Container>
                        <Row>
                            <Col className={css(styles.alignCenterVertical)}>
                                <div className={css(styles.logoWrapper)}>
                                    <Link to={config.routes.homeWebPlayer}>
                                        <IconNewNoaLogoWhiteText className={css(styles.logo)} />
                                    </Link>

                                    <div className={css(styles.logoWrapperVerticalLine)} />
                                    <p className={css(styles.lgoTagLine)}>The home of audio-journalism</p>
                                </div>
                            </Col>

                            <Col xs="auto">
                                <div className={css(styles.mobileLinks)}>
                                    <button
                                        onClick={() =>
                                            this.setState((prev) => ({
                                                ...prev,
                                                isMenuOpen: !prev.isMenuOpen,
                                            }))
                                        }
                                        className={css(styles.hamburger)}
                                        type="button">
                                        {this.state.isMenuOpen ? <CloseIcon /> : <HamburgerIcon />}
                                    </button>
                                    <div
                                        className={css(styles.mobileMenu, !this.state.isMenuOpen && styles.menuClosed)}>
                                        <Link to={config.routes.about} className={css(styles.removeLinkDecoration)}>
                                            <p className={css(styles.link, styles.about, styles.menuLink)}>About Us</p>
                                        </Link>
                                        <div className={css(styles.removeLinkDecoration)} onClick={this.chatToTeam}>
                                            <p className={css(styles.link, styles.about, styles.menuLink)}>
                                                Contact Us
                                            </p>
                                        </div>
                                        <Link to={config.routes.faq} className={css(styles.removeLinkDecoration)}>
                                            <p className={css(styles.link, styles.about, styles.menuLink)}>FAQs</p>
                                        </Link>
                                        {!this.props.user && (
                                            <p
                                                className={css(styles.link, styles.logIn, styles.menuLink)}
                                                onClick={this.onSignUpButtonClicked}>
                                                Sign up
                                            </p>
                                        )}
                                        {!this.props.user && (
                                            <p
                                                className={css(styles.link, styles.logIn, styles.menuLink)}
                                                onClick={this.showLogin}>
                                                Log In
                                            </p>
                                        )}
                                    </div>
                                </div>
                                <div className={css(styles.desktopLinks, styles.alignCenterVertical)}>
                                    <Link to={config.routes.about} className={css(styles.removeLinkDecoration)}>
                                        <p className={css(styles.link, styles.about)}>About Us</p>
                                    </Link>
                                    <Link to={config.routes.faq} className={css(styles.removeLinkDecoration)}>
                                        <p className={css(styles.link, styles.about)}>FAQs</p>
                                    </Link>
                                    {!this.props.user && (
                                        <p className={css(styles.link, styles.logIn)} onClick={this.showLogin}>
                                            Log In
                                        </p>
                                    )}

                                    <button
                                        type="button"
                                        className={css(styles.mainButton, newtheme.coreStyles.hideTiny)}
                                        onClick={this.onSignUpButtonClicked}>
                                        {buttonText || 'Start Listening'}
                                    </button>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        );
    }
}

const styles = StyleSheet.create({
    main: {
        [newtheme.cssBreakpoints.large]: {
            padding: 10,
        },
        [newtheme.cssBreakpoints.medium]: {
            padding: 10,
        },
        [newtheme.cssBreakpoints.tiny]: {
            padding: 10,
        },
        '@supports ((-webkit-backdrop-filter: blur(60px)) or (backdrop-filter: blur(60px)))': {
            background: 'rgba(3, 22, 41, 0.1)',
            backdropFilter: 'blur(60px)',
            '-webkit-backdrop-filter': 'blur(60px)',
        },
        background: 'rgba(3, 22, 41, .5)',
        fontFamily: 'Poppins',
        padding: 15,
        width: '100%',
        position: 'fixed',
        top: 0,
        zIndex: 999,
    },
    solidNavbar: {
        '@supports ((-webkit-backdrop-filter: blur(60px)) or (backdrop-filter: blur(60px)))': {
            background: '#031629',
            backdropFilter: 'none',
        },
        background: '#031629',
    },
    desktopLinks: {
        [newtheme.cssBreakpoints.small]: {
            display: 'none',
        },
        position: 'relative',
    },
    mobileLinks: {
        [newtheme.cssBreakpoints.small]: {
            display: 'block',
        },
        display: 'none',
    },

    menuClosed: {
        [newtheme.cssBreakpoints.medium]: {
            display: 'none',
        },
    },

    hamburger: {
        background: 'none',
        border: 'none',
        outline: 'none',
    },
    mobileMenu: {
        position: 'fixed',
        width: '100%',
        top: '55px',
        right: '0px',
        background: newtheme.darkmodeColors.backgroundNavy,
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        flexDirection: 'column',
        padding: 16,
    },
    menuLink: {
        [newtheme.cssBreakpoints.medium]: {
            margin: '4px 0',
            padding: '4px 0',
        },
        margin: '4px 0',
        padding: '4px 0',
    },
    logoWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
    },

    logoWrapperVerticalLine: {
        [newtheme.cssBreakpoints.medium]: {
            margin: '0px 14px',
            height: 35,
            marginLeft: 11,
        },
        [newtheme.cssBreakpoints.small]: {
            height: 30,
            margin: '0px 10px',
            marginLeft: 8,
            width: 1,
        },
        width: 2,
        height: 37,
        background: 'white',
        margin: '0px 18px',
    },

    lgoTagLine: {
        [newtheme.cssBreakpoints.medium]: {
            fontSize: 14,
            width: 130,
        },
        [newtheme.cssBreakpoints.small]: {
            fontSize: 13,
            width: 126,
        },
        fontSize: 16,
        color: newtheme.colors.white,
        width: 153,
        margin: 0,
        padding: 0,
        lineHeight: '122%',
    },

    logo: {
        [newtheme.cssBreakpoints.medium]: {
            height: 30.52,
            width: 89,
        },
        [newtheme.cssBreakpoints.tiny]: {
            height: 30.52,
            width: 89,
        },
        [newtheme.cssBreakpoints.smallerThanTiny]: {
            height: 24,
            width: 70,
        },
        height: 40,
        width: 111,
    },
    alignCenterVertical: {
        [newtheme.cssBreakpoints.tiny]: {
            padding: '0px 5px',
        },
        [newtheme.cssBreakpoints.minuscule]: {
            padding: 0,
        },
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    hideMobile: {
        [newtheme.cssBreakpoints.small]: {
            display: 'none',
        },
    },
    showMobile: {
        [newtheme.cssBreakpoints.small]: {
            display: 'block',
        },
        display: 'none',
    },
    dropdown: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        top: 0,
        right: 0,
    },
    hamburgerIcon: {
        stroke: 'white',
    },
    mainButton: {
        [newtheme.cssBreakpoints.medium]: {
            padding: '10px 20px',
            fontSize: 13,
            borderRadius: 5,
        },
        [newtheme.cssBreakpoints.tiny]: {
            padding: '7px 10px',
            fontSize: 12,
        },
        [newtheme.cssBreakpoints.minuscule]: {
            padding: '7px 5px',
            fontSize: 11,
        },
        ':hover': {
            backgroundColor: 'white',
            color: 'black',
        },
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: newtheme.colors.primaryBlue,
        color: 'white',
        border: 'none',
        borderRadius: 10,
        fontSize: 14,
        fontWeight: 500,
        padding: '14px 30px',
        marginLeft: 24,
    },
    removeLinkDecoration: {
        color: 'white',
    },
    link: {
        [newtheme.cssBreakpoints.medium]: {
            fontSize: 13,
        },
        [newtheme.cssBreakpoints.tiny]: {
            fontSize: 12,
        },
        ':hover': {
            textDecoration: 'underline',
        },
        cursor: 'pointer',
        fontSize: 14,
        fontWeight: 500,
        margin: 0,
    },
    logIn: {
        [newtheme.cssBreakpoints.tiny]: {
            paddingLeft: 0,
            paddingRight: 10,
        },
        marginLeft: 14,
    },
    about: {
        [newtheme.cssBreakpoints.small]: {
            marginLeft: 20,
            paddingTop: 0,
        },
        [newtheme.cssBreakpoints.tiny]: {
            marginLeft: 0,
            paddingRight: 25,
        },
        [newtheme.cssBreakpoints.smallerThanTiny]: {
            paddingRight: 20,
        },
        marginLeft: 10,
        marginRight: 10,
        paddingTop: 2,
    },
});

function mapStateToProps(state: IState): IPropsFromState {
    return {
        user: state.user.user,
        subscriptionProduct: getSelectedSubscriptionProduct(state),
    };
}

function mapDispatchToProps(dispatch: Dispatch): IPropsFromDispatch {
    return bindActionCreators({ openModal }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LandingPageNewNavbar));
